import React from 'react';
import PropTypes from 'prop-types';

import LinkHandler from '../link-handler';

import { ChildPage } from './styles';

/**
 * A block that links to a child page on standard advice pages
 */
const ChildPageLink = ({ path, title, description }) => (
  <ChildPage>
    <h4>
      <LinkHandler link={{ path }}>{title}</LinkHandler>
    </h4>
    <p>{description}</p>
  </ChildPage>
);

ChildPageLink.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default ChildPageLink;
